module.exports = __webpack_public_path__ + "img/shooting06.12b57881.jpeg";